import 'prismjs/prism';
import 'prismjs/plugins/autoloader/prism-autoloader';

// eslint-disable-next-line no-undef
Prism.plugins.autoloader.languages_path = '/assets/components/';
